import { render, staticRenderFns } from "./CandidateResponse.vue?vue&type=template&id=63ad1b84"
import script from "./CandidateResponse.vue?vue&type=script&lang=js"
export * from "./CandidateResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports